/* ==========================================================================
   Tati Jewels — tj-currency.js  (local-currency display layer)
   The store charges in one currency (BASE — AED once the store currency is AED).
   Every Gulf currency we show is fixed to the US dollar, so the conversions are exact
   pegs. This layer finds every amount on the page — ours, Kaching's offer bars — in
   either "$25" or "AED 89" form, and writes it in the visitor's currency. UAE visitors
   see the store currency untouched (only "AED 89.00" is tidied to "AED 89").
   It keeps working when apps re-render, and always says what checkout charges.
   Anything inside [data-tj-usd] is the real charged amount and is left alone.
   ========================================================================== */
(function () {
  'use strict';
  var RATES = {                        /* units per 1 USD */
    USD: { r: 1,      d: 2, p: '$' },
    AED: { r: 3.6725, d: 0, p: 'AED ' },
    SAR: { r: 3.75,   d: 0, p: 'SAR ' },
    QAR: { r: 3.64,   d: 0, p: 'QAR ' },
    OMR: { r: 0.3845, d: 2, p: 'OMR ' },
    BHD: { r: 0.376,  d: 2, p: 'BHD ' },
    KWD: { r: 0.307,  d: 2, p: 'KWD ' },
    JOD: { r: 0.709,  d: 2, p: 'JOD ' }
  };
  var BY_COUNTRY = { AE: 'AED', SA: 'SAR', QA: 'QAR', OM: 'OMR', BH: 'BHD', KW: 'KWD', JO: 'JOD' };
  var CFG = window.TJCurrency || {};
  var BASE = RATES[CFG.base] ? CFG.base : 'USD';
  var KEY = 'tj_currency';

  /* a hand-picked currency is remembered only for the country it was picked in */
  function stored() { try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.k === CFG.country && RATES[v.c] ? v.c : null; } catch (e) { return null; } }
  function store(c) { try { localStorage.setItem(KEY, JSON.stringify({ c: c, k: CFG.country })); } catch (e) {} }
  var cur = stored() || BY_COUNTRY[CFG.country] || BASE;

  function num(v, d) { return v.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }); }
  /* amount (in `from`) → text in `to` (default: the visitor's currency) */
  function conv(amount, from, to) {
    from = from || BASE; to = to || cur;
    var c = RATES[to];
    if (from === to) {                 /* same currency: exact, never round real decimals away */
      var whole = Math.abs(amount - Math.round(amount)) < 0.005;
      return c.p + num(whole ? Math.round(amount) : amount, whole ? 0 : 2);
    }
    var v = amount / RATES[from].r * c.r;
    return c.p + num(c.d === 0 ? Math.round(v) : v, c.d);
  }
  function fmt(amountInBase, code) { return conv(amountInBase, BASE, code || cur); }
  function baseFmt(amountInBase) { return conv(amountInBase, BASE, BASE); }

  /* "$25", "$25.00", "AED 89", "AED 1,234.50", "Dhs. 89.00", "89.00 AED", "-$5" — also inside bidi isolates */
  var NUM = '((?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d{1,2})?)';
  var RX = new RegExp('([-\\u2212]?)(?:(\\$)\\s?' + NUM + '|\\b(?:AED|Dhs\\.?)\\s?' + NUM + '|' + NUM + '\\s?(?:AED|Dhs)\\b)', 'g');
  var HINT = /\$|AED|Dhs/;
  /* Kaching copy promises free shipping with the gift-box add-on: true in the UAE only */
  var NOT_UAE = CFG.country !== 'AE';
  var STRIP = /\s*and benefit from free shipping!?/ig;

  var ORIG = new WeakMap(), WROTE = new WeakMap();
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TEMPLATE: 1 };
  function skippable(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) {
      if (SKIP[n.tagName] || n.hasAttribute('data-tj-usd')) return true;
    }
    return false;
  }
  function rewrite(src) {
    var out = src;
    if (HINT.test(src)) out = out.replace(RX, function (m, neg, usd, nUsd, nAedP, nAedS) {
      var from = usd ? 'USD' : 'AED';
      var n = parseFloat(String(nUsd || nAedP || nAedS).replace(/,/g, ''));
      if (isNaN(n)) return m;
      return neg + conv(n, from, cur);
    });
    if (NOT_UAE) out = out.replace(STRIP, '');
    return out;
  }
  function convertText(node) {
    var mine = WROTE.get(node) === node.data;
    var src = mine ? ORIG.get(node) : node.data;          /* an app re-rendered → new source */
    if (!src || !(HINT.test(src) || (NOT_UAE && /free shipping/i.test(src)))) return;
    if (node.parentNode && skippable(node.parentNode)) return;
    var out = rewrite(src);
    ORIG.set(node, src);
    WROTE.set(node, out);
    if (out !== node.data) node.data = out;
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { convertText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) convertText(n);
  }

  /* ---------- honest notes: what the customer is actually charged ---------- */
  var cartTotal = null, pending = null;
  function refreshCart() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price; pending = null; paintNotes(); })
      .catch(function () { pending = null; });
    return pending;
  }
  function fill(t) { return String(t || '').replace(/\[code\]/g, BASE).replace(/\[cur\]/g, cur); }
  function noteText() {
    if (cur === BASE || cartTotal == null) return '';
    var b = baseFmt(cartTotal / 100);
    return fill(CFG.checkoutNote || 'You pay in [code] at checkout: [base] (≈ [local]).')
      .replace('[base]', b).replace('[usd]', b).replace('[local]', fmt(cartTotal / 100));
  }
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  function paintNotes() {
    var t = noteText();
    /* these quote the real charged amount on purpose: mark them so the converter leaves them alone,
       and only write when the text changes (every write is a DOM mutation that wakes the observer) */
    Array.prototype.forEach.call(document.querySelectorAll('[data-tj-checkout-note]'), function (el) {
      if (!el.hasAttribute('data-tj-usd')) el.setAttribute('data-tj-usd', '');
      setText(el, t);
      if (el.hidden !== !t) el.hidden = !t;
    });
    Array.prototype.forEach.call(document.querySelectorAll('kaching-cart-drawer, kaching-cart'), function (drawer) {
      var btn = Array.prototype.filter.call(drawer.querySelectorAll('button, a'), function (b) { return /check\s?out/i.test(b.textContent || ''); })[0];
      if (!btn || !btn.parentNode) return;
      var note = drawer.querySelector('.tj-ck-note');
      if (!note) { note = document.createElement('p'); note.className = 'tj-ck-note'; note.setAttribute('data-tj-usd', ''); btn.parentNode.insertBefore(note, btn); }
      setText(note, t);
      if (note.hidden !== !t) note.hidden = !t;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tj-usd-hint]'), function (el) { if (el.hidden !== (cur === BASE)) el.hidden = cur === BASE; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tj-rate-note]'), function (el) {
      var rt = fill(cur === BASE ? (CFG.baseNote || 'Prices in [code].') : (CFG.rateNote || 'Prices shown in [cur] for reference. Orders are charged in [code].'));
      if (!el.hasAttribute('data-tj-usd')) el.setAttribute('data-tj-usd', '');
      setText(el, rt);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tj-cur-select]'), function (s) { if (s.value !== cur) s.value = cur; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tj-cur-label]'), function (s) { setText(s, cur); });
  }

  function setCurrency(c) {
    if (!RATES[c]) return;
    cur = c; store(c);
    document.documentElement.setAttribute('data-currency', c);
    walk(document.body); paintNotes();
  }

  /* ---------- keep up with apps that render after us ---------- */
  var queue = [], scheduled = false;
  function flush() {
    scheduled = false;
    var list = queue; queue = [];
    var touchedCart = false;
    list.forEach(function (n) {
      walk(n);
      if (!touchedCart && n.nodeType === 1 && n.closest && n.closest('kaching-cart-drawer, kaching-cart')) touchedCart = true;
    });
    if (touchedCart) refreshCart(); else paintNotes();
  }
  /* microtask, not requestAnimationFrame: runs before the next paint (no flash of the raw amount) and also in
     background tabs. Safety valve: if something keeps rewriting the same text (an app fighting us), back off
     to a timer so the page can never lock up in a microtask loop. */
  var burst = 0, burstAt = 0;
  function enqueue(n) {
    queue.push(n);
    if (scheduled) return;
    scheduled = true;
    var now = Date.now(); if (now - burstAt > 1000) { burstAt = now; burst = 0; }
    if (++burst > 40) setTimeout(flush, 250); else Promise.resolve().then(flush);
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'characterData') { if (WROTE.get(m.target) !== m.target.data) enqueue(m.target); }
      else for (var j = 0; j < m.addedNodes.length; j++) { var a = m.addedNodes[j]; var host = a.nodeType === 1 ? a : a.parentNode; if (host && host.closest && host.closest('[data-tj-usd]')) continue; enqueue(a); }
    }
  });

  function start() {
    document.documentElement.setAttribute('data-currency', cur);
    walk(document.body);
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-tj-cur-select]')) setCurrency(e.target.value); });
    refreshCart();
    /* cart changes made by any app */
    var _f = window.fetch;
    if (_f) window.fetch = function (u) {
      var p = _f.apply(this, arguments);
      try { if (/\/cart\/(add|change|update|clear)/.test(String(u && u.url || u))) p.then(function () { setTimeout(refreshCart, 150); }); } catch (e) {}
      return p;
    };
  }
  window.TJCur = { set: setCurrency, get: function () { return cur; }, base: BASE, fmt: fmt, baseFmt: baseFmt, conv: conv, rates: RATES };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
